export default {
    'Menu': 'Меню'
};



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mmenu-js/dist/core/oncanvas/translations/ru.js
// module id = 37
// module chunks = 0